/**
 * 友盟（CNZZ）统计事件上报
 */
export const useCnzz = () => {
  /**
   * 上报事件到友盟
   * @param category - 事件分类
   * @param action - 事件动作
   * @param label - 事件标签
   * @param value - 事件值（可选）
   */
  const trackEvent = (
    category: string,
    action: string,
    label: string,
    value?: number,
  ) => {
    if (typeof window !== 'undefined' && window._czc) {
      const params: any[] = ['_trackEvent', category, action, label]
      if (value !== undefined) {
        params.push(value)
      }
      window._czc.push(params)
    }
  }

  return {
    trackEvent,
  }
}
